import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import {
  resetData,
  setInputs,
  setOutputs
} from 'redux/actions/FinancialModelActions';
import SelectComponent from './Select';

import PeerOperatingModal from './PeerOperatingModal/PeerOperatingModal';

import TableIncome from './TableIncome';
import ButtonPeer from './ButtonPeer';
import TableCash from './TableCash';
import TableBalance from './TableBalance';
import SendModal from './SendModal';
import ExportButton from './ExportButton';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '20px 0'
  },
  buttonDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  rightButtons: {
    display: 'flex',
    alignItems: 'center'
  },
  export: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    textTransform: 'lowercase',
    fontWeight: 'bold',
    borderColor: '#002380',
    borderRadius: 0,
    marginRight: '1rem',
    minWidth: '145px'
  },
  send: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    textTransform: 'lowercase',
    fontWeight: 'bold',
    borderRadius: 0,
    minWidth: '145px',
    marginLeft: '30px'
  },
  save: {
    background: '#6D7278',
    fontFamily: 'PT sans',
    fontSize: '16px',
    color: '#FFF',
    textTransform: 'lowercase',
    fontWeight: 'bold',
    borderRadius: 0,
    minWidth: '145px'
  }
}));

const objectTest = {
  add_back_histo_imp_gw_intangible: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  adj_ebitda_net_interest: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  asso: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  cap_increase: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  cap_reduction: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  capex_p: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  cash_beginning: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  cash_cash_eq: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  cash_end: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  cash_roce: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  cfff: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  cffi: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  cffo: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  change_cash: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  change_y_y: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  deferred_tax_liab: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  depr_amort: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  depr_amort_p: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  div_fcf_equity: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  div_paid: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  ebita_growth: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  ebitda: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  ebitda_cagr: {
    '_1-5': '',
    '_2-5': ''
  },
  ebitda_growth: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  ebitda_margin: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  equity_ex_mino: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  goodwill: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  gross_fin_debt: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  gross_gw_other_intangible: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  gross_margin: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  gross_profit: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  group_revenues: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  interest_exp: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  interest_invest_income: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  interest_rate: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  invest_sub_asso: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  liab_held_sale: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  mino: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  nce: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  net_fin_debt: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  net_fin_debt_adj_ebitda: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  net_fin_debt_adj_ebitda_capex: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  net_fin_debt_equity: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  net_fin_debt_equity_net_fin_debt: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  net_income: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  net_income_growth: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  net_interest: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  ntce: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  nwc: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  nwc_change: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  nwc_p: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  o_w_depr_amort_charge: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  o_w_tax_paid: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  op_cash_flow: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  operating_profit: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  operating_profit_margin: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  other_cfff: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  other_cffi: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  other_liab: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  pbt: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  pbt_op_cash_adj: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  pension_liab: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  profit_loss_mino: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  provisions: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  revenues_cagr: {
    '_1-5': null,
    '_2-5': null
  },
  revenues_growth: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  roce: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  roe: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  share_profit_loss_asso: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  tangible_fixed: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  tax_charge: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  tax_rate: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  total_net_assets: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  total_net_capex: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  total_net_fin_debt: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  total_net_liab: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  total_unusual: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  unlevered_fcf_ebitda: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  },
  unlevered_fcf_op_profit: {
    '_-1': null,
    _0: null,
    _1: null,
    _2: null,
    _3: null,
    _4: null,
    _5: null
  }
};

const FinancialModeling = () => {
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const [scenario, setScenario] = useState({});
  const [dataFetched, setDataFetched] = useState(objectTest);
  const [inputObject, setInputObject] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [sendModalOpen, setSendModalOpen] = useState(false);
  const classes = useStyles();

  const fetchData = (scenario) => {
    dispatch(setOutputs(scenario.output.outputs));
    dispatch(setInputs(scenario.input_object));
    setScenario(scenario);
  };

  return (
    <>
      <PeerOperatingModal
        onClose={() => setModalOpen(false)}
        open={modalOpen}
      />
      <SendModal onClose={() => setSendModalOpen(false)} open={sendModalOpen} />
      <h5>You can build your own based on different sources of data</h5>
      <div className={classes.container}>
        <SelectComponent selectScenario={fetchData} />
        <ButtonPeer click={() => setModalOpen(true)} />
      </div>

      {/* <button onClick={() => dispatch(resetData())}>reset data</button> */}
      <TableIncome
        dataFetched={dataFetched}
        inputObject={inputObject}
        isLoading={isLoading}
        scenario={scenario}
      />
      <div>
        <ButtonPeer click={() => setModalOpen(true)} marged />
        <TableCash scenario={scenario} />
      </div>
      <TableBalance />
      <div className={classes.buttonDiv}>
        <div>
          <Button className={classes.save} variant="contained">
            save
          </Button>
        </div>
        <div className={classes.rightButtons}>
          <ExportButton />
          <Button
            className={classes.send}
            color="primary"
            onClick={() => {}}
            variant="contained">
            send to issuer
          </Button>
        </div>
      </div>
    </>
  );
};

export default FinancialModeling;
